export default __webpack_public_path__ + "static/media/hero-level-2-chars-mob.5fb9451e.webp";